export enum PackTypes {
  ALL = "all",
  PRIVATE = "private",
  TEAM = "team",
}

export type TypeofPack = PackTypes.ALL | PackTypes.TEAM | PackTypes.PRIVATE;

export enum PacksSortableKeys {
  title = "title",
  updated = "updated",
}

export const isValidPackType = (value: string | PackTypes): value is PackTypes => {
  return Object.values(PackTypes).some((x: any) => x === value);
};

export type Pack = {
  anon?: {
    identifier: string;
    is_valid: boolean;
  };
  base_id?: string;
  created: string;
  created_by?: string;
  email?: string;
  id: string;
  index_enabled: boolean;
  is_shared: boolean;
  joined?: boolean;
  meta: Record<string, any>;
  permission: string;
  show_bio: boolean;
  superpack_id?: string;
  sync_hash: string;
  team_share?: boolean;
  title: string;
  updated: string
  upgradable_permission?: string;
  key?: any;
  user: {
    email: string;
    first_name: string;
    has_avatar: boolean;
    id: string;
    last_name: string;
  }
}
